export const EVT_PASSWORD = 'password';
export const EVT_RECOVER_PASSWORD_START = 'recover-password-start';
export const EVT_RECOVER_PASSWORD_SUBMIT = 'recover-password-submit';
export const EVT_RECOVER_PASSWORD_LOGIN = 'recover-password-login';
export const EVT_SUBSCRIPTION_CONFIRM = 'subscription-confirm';
export const EVT_SUBSCRIPTION_VERIFICATION = 'subscription-verification';
export const EVT_FOOTER = 'footer';
export const EVT_NAVIGATION_CATEGORY = 'navigation';
export const EVT_LOGIN = 'login';
export const EVT_LOGIN_SUBMIT = 'login-submit';
export const EVT_LOGIN_SUCCESS = 'login-success';
export const EVT_SUBSCRIPTION_START = 'subscription-start';
export const EVT_ERROR = 'error';
export const EVT_FUNNEL = 'funnel';
export const EVT_ACTION_EMAIL_CONFIRM = 'email-confirm';
export const EVT_ACTION_PASSWORD_CONFIRM = 'password-confirm';
export const EVT_ACTION_NAME_CONFIRM = 'name-confirm';
export const EVT_ACTION_GENDER_CONFIRM = 'gender-confirm';
export const EVT_ACTION_BIRTHDATE_CONFIRM = 'birthdate-confirm';
export const EVT_ACTION_PRIVACY_CONFIRM = 'privacy-confirm';
export const EVT_ACTION_EMAIL_RESEND = 'email-resend';
export const EVT_ACTION_EMAIL_VERIFY = 'email-verify';

export const EVT_SEND_EMAIL = 'send-email';
export const EVT_SET_PASSWORD = 'set-password';
export const EVT_REGISTER = 'register';
export const EVT_EMAIL = 'email';
export const EVT_NAME = 'name';
export const EVT_GENDER = 'gender';
export const EVT_BIRTHDATE = 'birthdate';
export const EVT_PRIVACY = 'privacy';
export const EVT_VERIFY = 'verify';
export const EVT_TEXT_LINK = 'textlink';

export const EVT_ELEMENT_INTERACTION = 'click';
export const EVT_ELEMENT_TYPE_BUTTON = 'button';
export const EVT_ELEMENT_NAME_PASSWORD_RECOVERY = 'password-recovery';
export const EVT_ELEMENT_TYPE_HYPERLINK = 'hyperlink';
export const EVT_ELEMENT_STYLE_PRIMARY = 'primary';
export const EVT_ELEMENT_STYLE_TERNARY = 'ternary';
